module.exports = __webpack_public_path__ + "6650bd91bae0a053775c46ebeb817fa2.pdf";